import { Pipe, PipeTransform } from '@angular/core';
import { IQuotationBlock, IQuotationCost } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { QuotationPriceToolsService } from "./quotation-price-tools.service";

@Pipe({
    name: 'extractCost',
})
export class ExtractCostPipe implements PipeTransform {

    constructor(private readonly priceToolsService: QuotationPriceToolsService) {
    }

    public transform(block: IQuotationBlock, updated: number = 0): IQuotationCost {
        if (this.priceToolsService.hasTotalPrice(block) && block.totalPrices.length === 1 && block.totalPrices[0].cost) {
            return block.totalPrices[0].cost;
        }

        if (this.priceToolsService.hasCostValue(block)) {
            return block.cost;
        }
        return null;
    }
}

